import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

// Import images
import Img1 from '../assets/images/features/img-1.png';
import HomeUrl from '../assets/images/home-border.png';

export default class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pricing: [
        {
          id: 1,
          title: "Basic",
          description: 'Ideal for startups and small businesses looking to establish an online presence.',
          icon: 'mdi-web',
          titlePrimary: false,
          regularprice: '£499',
          saleprice: '£399',
          pricingTag: false,
          child: [
            { btitle: '1', title: "Custom Website", icon: "mdi-checkbox-marked-circle text-success" },
            { btitle: 'SEO', title: "Basic SEO", icon: "mdi-checkbox-marked-circle text-success" },
            { btitle: 'No', title: "Social Media Integration", icon: "mdi-close-circle text-danger" },
            { btitle: 'Email', title: "Basic Support", icon: "mdi-checkbox-marked-circle text-success" },
          ],
        },
        {
          id: 2,
          title: "Business",
          titlePrimary: true,
          description: 'Perfect for growing businesses needing more visibility and enhanced functionality.',
          icon: 'mdi-chart-line',
          regularprice: '£799',
          saleprice: '£699',
          pricingTag: true,
          child: [
            { btitle: '1', title: "Custom Website with E-Commerce", icon: "mdi-checkbox-marked-circle text-success" },
            { btitle: 'SEO', title: "Advanced SEO", icon: "mdi-checkbox-marked-circle text-success" },
            { btitle: 'Yes', title: "Social Media Integration", icon: "mdi-checkbox-marked-circle text-success" },
            { btitle: 'Chat & Email', title: "Priority Support", icon: "mdi-checkbox-marked-circle text-success" },
          ],
        },
        {
          id: 3,
          title: "Enterprise",
          description: 'Comprehensive solutions for established businesses seeking full-service digital solutions.',
          icon: 'mdi-office-building',
          titlePrimary: false,
          regularprice: '£1499',
          saleprice: '£1299',
          pricingTag: false,
          child: [
            { btitle: 'Unlimited', title: "Custom Websites & Apps", icon: "mdi-checkbox-marked-circle text-success" },
            { btitle: 'SEO & SEM', title: "Complete SEO & Ad Management", icon: "mdi-checkbox-marked-circle text-success" },
            { btitle: 'Yes', title: "Social Media & API Integration", icon: "mdi-checkbox-marked-circle text-success" },
            { btitle: '24/7 Support', title: "Dedicated Account Manager", icon: "mdi-checkbox-marked-circle text-success" },
          ],
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <section className="section bg-light bg-features">
          <Container>
            <Row className="align-items-center">
              <Col lg={5}>
                <div style={{ marginTop: '20px', position: 'relative' }}>
                  <img src={Img1} className="img-fluid" alt="" style={{ width: '100%', borderRadius: '8px' }} />
                </div>
              </Col>
              <Col lg={6} className="offset-lg-1">
                <div style={{ marginTop: '20px' }}>
                  <h2>Flexible Plans for Every Business</h2>
                  <p style={{ marginTop: '20px', color: '#6c757d' }}>
                    At Webora, we offer tailored pricing plans designed to meet the unique needs of businesses at every stage. Whether you're a startup looking to establish an online presence or an enterprise needing a full-service digital strategy, we have a plan for you.
                  </p>
                  <div className="mt-4">
                    <Link to="#" className="btn btn-primary">Learn More</Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section" id="pricing">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="title-box text-center">
                  <h3 className="title-heading mt-4">Our Pricing Packages</h3>
                  <p className="text-muted f-17 mt-3">Choose the package that best suits your business needs, from basic web presence to advanced digital solutions.</p>
                  <img src={HomeUrl} height="15" className="mt-3" alt="" />
                </div>
              </Col>
            </Row>
            <Row className="mt-5 pt-4">
              {this.state.pricing.map((item, key) => (
                <Col lg="4" key={key}>
                  <div
                    className="pricing-box d-flex flex-column justify-content-between"
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                      padding: '20px',
                      textAlign: 'center',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      transition: 'transform 0.2s ease',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-5px)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                  >
                    {item.pricingTag && (
                      <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                        <span className="badge badge-primary">Featured</span>
                      </div>
                    )}

                    <i className={"h1 mdi " + item.icon}></i>
                    <h4 className="f-20" style={{ color: item.titlePrimary ? '#007bff' : '#333' }}>{item.title}</h4>

                    <div className="mt-4 pt-2">
                      <p className="mb-2 f-18" style={{ fontWeight: 'bold' }}>Features</p>
                      {item.child.map((linkItem, linkkey) => (
                        <p className="mb-2" key={linkkey}>
                          <i className={"mdi " + linkItem.icon + " f-18 mr-2"}></i>
                          <b>{linkItem.btitle}</b> {linkItem.title}
                        </p>
                      ))}
                    </div>
                    <p style={{ marginTop: '20px', color: '#6c757d' }}>{item.description}</p>
                    <div className="pricing-plan mt-4 pt-2">
                      <h4 className="text-muted">
                        <s>{item.regularprice}</s> <span className="plan pl-3 text-dark">{item.saleprice}</span>
                      </h4>
                      <p className="text-muted mb-0">Per Month</p>
                    </div>
                    <div className="mt-4 pt-3">
                      <Link to="#" className="btn btn-primary btn-rounded">Get Started</Link>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
